var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.833 29a4.835 4.835 0 004.834-4.833v-4.834H4.833A4.835 4.835 0 000 24.167 4.835 4.835 0 004.833 29z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.5a4.835 4.835 0 014.833-4.833h4.834v9.666H4.833A4.835 4.835 0 010 14.5z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.833A4.835 4.835 0 014.833 0h4.834v9.667H4.833A4.835 4.835 0 010 4.833z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.667 0H14.5a4.835 4.835 0 014.833 4.833A4.835 4.835 0 0114.5 9.667H9.667V0z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 14.5a4.835 4.835 0 01-4.833 4.833A4.835 4.835 0 019.667 14.5 4.835 4.835 0 0114.5 9.667a4.835 4.835 0 014.833 4.833z",
    fill: "#1ABCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.832bb45288453eed9099de189f44d5ee.svg";
export { ForwardRef as ReactComponent };